import { LineChartIcon } from "@/assets/icons";
import { MESSAGE } from "@/constants/message";

interface NoDataWidgetContentProps {
  title?: string;
  description?: string;
}

const NoDataWidgetContent = ({
  title = MESSAGE.WIDGET_NO_DATA_DEFAULT_TITLE,
  description = MESSAGE.WIDGET_NO_DATA_DEFAULT_DESCRIPTION
}: NoDataWidgetContentProps) => {
  return (
    <div className="flex flex-col gap-4 justify-center items-center">
      <div className="w-20 h-20 bg-whisper rounded-lg rotate-12 shadow-[0px_4px_24px_5px_#CECECE66] flex justify-center items-center">
        <LineChartIcon className="w-8 h-8 fill-dim-gray -rotate-12" />
      </div>
      <p className="text-txtPlaceholder font-semibold">{title}</p>
      <span className="text-sm text-txtPlaceholder w-80 text-center">
        {description}
      </span>
    </div>
  );
};

export default NoDataWidgetContent;
